import {Component, Input, OnInit} from '@angular/core';
import {V3Audio, V3ExerciseSessionQuestionBase} from "../../../model/v3/cspa";

@Component({
    selector: 'app-audio-result',
    templateUrl: './audio-result.component.html',
    styleUrls: ['./audio-result.component.scss'],
    standalone: false
})
export class AudioResultComponent  implements OnInit {
  @Input() questions: V3ExerciseSessionQuestionBase<V3Audio>[]
  constructor() {
  }

  ngOnInit(): void {
  }


  getQuestion(q: V3ExerciseSessionQuestionBase<V3Audio>) {
    return q.questionDef.audioTranscription
  }

  getStudentAnswer(q: V3ExerciseSessionQuestionBase<V3Audio>) {
    return q.questionDef.answerDef.answerHolder?.answer?.map(a => a.val.join("; ")) || "-"
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestionBase<V3Audio>) {
    return q.questionDef.answerDef.answer.map(a => a.val.join(", ")).join("; ")
  }

  isAnswerIncorrect(q: V3ExerciseSessionQuestionBase<V3Audio>) {
    return q.score == 0 && !!q.questionDef.answerDef.answerHolder
  }
}
